"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const sub_layout_1 = require("../../../../layouts/sub-layout");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions/actions");
const react_spinners_1 = require("react-spinners");
const themes_1 = require("../../../../utils/themes");
const model_tuning_step1_1 = require("../subSteps/modelTuning/model-tuning-step1");
const model_tuning_step2_1 = require("../subSteps/modelTuning/model-tuning-step2");
const model_tuning_step3_1 = require("../subSteps/modelTuning/model-tuning-step3");
const model_tunning_step_rcams_2_1 = require("../subSteps/modelTuning/model-tunning-step-rcams-2");
const model_tuning_step_rcams_1_1 = require("../subSteps/modelTuning/model-tuning-step-rcams-1");
const api_1 = require("../../../../utils/api");
const icons_1 = require("../../../../utils/icons");
const graph_component_1 = tslib_1.__importDefault(require("../../../../layouts/graph-component"));
const environment_1 = require("../../../../../../environments/environment");
const Utils_1 = require("../../../../utils/Utils");
const style_1 = tslib_1.__importDefault(require("src/app/auto-ml/utils/style"));
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
function ModelTuning(props) {
    const dispatch = react_redux_1.useDispatch();
    const mainStep = react_redux_1.useSelector((state) => state.mainStep.no);
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const styleLocal = style_1.default();
    const [currentStep, setCurrentStep] = react_1.useState(0);
    const [modelDetails, setModelDetails] = react_1.useState({});
    const [checkedModelDetails, setCheckedModelDetails] = react_1.useState({});
    const [isModelSaved, setIsModelSaved] = react_1.useState(false);
    const [allSavedModels, setAllSavedModels] = react_1.useState([]);
    const [selectedFinalModel, setSelectedFinalModel] = react_1.useState(null);
    const [isFinalModelSelected, setIsFinalModelSelected] = react_1.useState(false);
    const [visualizationData, setVisualizationData] = react_1.useState([]);
    const [isVisualizationNeeded, setIsVisualizationNeeded] = react_1.useState(false);
    const [isVisualizationTable, setIsVisualizationTable] = react_1.useState(false);
    const [isVisualizationFinal, setIsVisualizationFinal] = react_1.useState(false);
    const [errorMessages, setErrorMessage] = react_1.useState({});
    const [modelSelectionData, setModelSelectionData] = react_1.useState({});
    const [subStepperData, setSubStepData] = react_1.useState([
        {
            required: true,
            text: "Model Selection",
            active: true,
        },
        {
            required: true,
            text: "Performance Testing",
            active: false,
        },
        {
            required: false,
            text: "Models",
            active: false,
        },
    ]);
    const [loading, setLoading] = react_1.useState(false);
    const [snackbarOpen, setSnackbarOpen] = react_1.useState(false);
    const [isGraphView, setIsGraphView] = react_1.useState(false);
    const [graphPath, setGraphPath] = react_1.useState("");
    const isRcaMsProblem = projectInfo.problemtype === "rca_ms";
    const isAnomalyDetection = projectInfo.problemType === "anomalydetection";
    const gridSize = (currentStep === 0 && isRcaMsProblem) || (currentStep === 2 && isRcaMsProblem) ?
        (currentStep === 0 ? 3 : 5) : 4;
    const mounted = react_1.useRef(true);
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    const setCurrentStepByClick = (step) => {
        if (step >= 0 && step < subStepperData.length && step <= currentStep) {
            const updatedSubStepperData = subStepperData.map((item, index) => (Object.assign({}, item, { active: index <= step })));
            setSubStepData(updatedSubStepperData);
            setCurrentStep(step);
        }
    };
    react_1.useEffect(() => {
        return () => {
            mounted.current = false;
        };
    }, [projectInfo]);
    react_1.useEffect(() => {
        localStorage.setItem('pageFlag', 4);
    }, []);
    const validateFields = () => {
        let isValid = true;
        let errors = {};
        if (projectInfo.problemtype === "rca_ms") {
            if (modelSelectionData.method == "") {
                errors.method = "Method is required";
                isValid = false;
            }
        }
        else {
            if (!modelDetails.algorithm) {
                isValid = false;
                errors.modelDetailsError = "* Please Select an Algorithm";
            }
        }
        setErrorMessage((prevData) => (Object.assign({}, prevData, errors)));
        return isValid;
    };
    const increaseStep = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        let lastIndex = 0;
        subStepperData.forEach((d, i) => {
            if (d.active === true) {
                lastIndex = i;
            }
        });
        try {
            if (lastIndex === 0 && projectInfo.problemtype === "rca_ms") {
                setIsVisualizationFinal(false);
                if (!validateFields()) {
                    return;
                }
                const model_selection_data = {
                    projectname: projectInfo.projectname,
                    problemtype: projectInfo.problemtype,
                    version_name: projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                    model_selection: modelSelectionData,
                };
                dispatch(actions_1.saveModelSelection(modelSelectionData));
                const response = yield api_1.modelSelection(model_selection_data);
            }
            if (lastIndex === 0 && !isVisualizationFinal && projectInfo.problemtype !== "rca_ms") {
                if (!validateFields()) {
                    return;
                }
                console.log("modelDetails to save: ", modelDetails);
                const model_selection_data = {
                    projectname: projectInfo.projectname,
                    problemtype: projectInfo.problemtype,
                    version_name: projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                    modelselection: modelDetails,
                };
                const modelSelectionRes = yield api_1.modelSelection(model_selection_data);
                if (modelSelectionRes.data.graph_visualizations &&
                    Object.keys(modelSelectionRes.data.graph_visualizations).length > 0) {
                    setIsVisualizationNeeded(true);
                    setVisualizationData(modelSelectionRes.data.graph_visualizations);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
                setCheckedModelDetails(modelSelectionRes.data.performance_report);
            }
            if (lastIndex === 1) {
                const userDetails = {
                    projectname: projectInfo.projectname,
                    problemtype: projectInfo.problemtype,
                    version_name: projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                };
                try {
                    const modelsRes = yield api_1.getSavedModels(userDetails);
                    console.log("model res: ", modelsRes.data.model_selection_tests);
                    setAllSavedModels(modelsRes.data.model_selection_tests);
                }
                catch (error) {
                    console.error("Failed to fetch models:", error);
                }
            }
            if (lastIndex === 2) {
                if (!isFinalModelSelected) {
                    setLoading(false);
                    return;
                }
                let selected_final_model;
                if (projectInfo.problemtype === "rca_ms") {
                    selected_final_model = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        finalized_model_info: selectedFinalModel.performancereport,
                        userid: js_cookie_1.default.get('USER_ID'),
                    };
                }
                else {
                    selected_final_model = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        finalized_model_info: selectedFinalModel,
                        userid: js_cookie_1.default.get('USER_ID'),
                    };
                }
                console.log(selectedFinalModel.performancereport);
                const finalModelRes = yield api_1.selectModel(selected_final_model);
                dispatch(actions_1.saveFinalData(selectedFinalModel.performancereport));
            }
            if (lastIndex + 1 < subStepperData.length) {
                let newSubStep = [...subStepperData];
                if ((projectInfo.problemType === "regression" || projectInfo.problemtype === "RootCauseAnalysis") && isVisualizationFinal) {
                    newSubStep[lastIndex + 1].active = true;
                    setSubStepData(newSubStep);
                    lastIndex = lastIndex + 1;
                }
                else {
                    newSubStep[lastIndex + 1].active = true;
                    setSubStepData(newSubStep);
                    lastIndex = lastIndex + 1;
                }
            }
            else {
                dispatch(actions_1.changeMainStep(mainStep + 1));
                localStorage.setItem('pageFlag', 5);
            }
            setCurrentStep(lastIndex);
        }
        catch (error) {
            console.log("Error in model selection", error);
        }
        finally {
            if (mounted.current) {
                setLoading(false);
            }
        }
    });
    const decreaseStep = () => {
        let lastIndex = 0;
        subStepperData.forEach((d, i) => {
            if (d.active === true) {
                lastIndex = i;
            }
        });
        if (lastIndex === 1) {
            setIsModelSaved(false);
            setIsVisualizationNeeded(false);
            setIsVisualizationTable(false);
            setIsVisualizationFinal(false);
        }
        if (lastIndex > 0) {
            let newSubStep = [...subStepperData];
            newSubStep[lastIndex].active = false;
            newSubStep[lastIndex - 1].active = true;
            setSubStepData(newSubStep);
            lastIndex = lastIndex - 1;
        }
        else {
            dispatch(actions_1.changeMainStep(mainStep - 1));
            localStorage.setItem('pageFlag', 3);
        }
        setCurrentStep(lastIndex);
    };
    const saveCheckedModel = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        const save_model_data = {
            projectname: projectInfo.projectname,
            problemtype: projectInfo.problemtype,
            version_name: projectInfo.version_name,
            userid: js_cookie_1.default.get('USER_ID'),
        };
        const savedRes = yield api_1.saveModel(save_model_data);
        console.log("savedRes", savedRes);
        if (savedRes.data.status === "success") {
            setSnackbarOpen(true);
        }
        setIsModelSaved(true);
        setLoading(false);
    });
    const renderVisualizeTable = () => {
        setIsVisualizationTable(true);
        setIsVisualizationFinal(true);
    };
    const handleTryNewModel = () => {
        dispatch(actions_1.changeMainStep(mainStep - 1));
        localStorage.setItem('pageFlag', 3);
    };
    const handleGraphView = (index) => {
        console.log(index);
        setIsGraphView(true);
        console.log(allSavedModels);
        const graphPath = allSavedModels.filter((model, id) => id == index)[0].graph_df_path;
        const graphPath_env = `${environment_1.environment.MLBE}/${Utils_1.getRelativePath(graphPath)}`;
        setGraphPath(graphPath_env);
    };
    const closeGraph = () => {
        setIsGraphView(false);
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        loading && (react_1.default.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(128, 128, 128, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            } },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6, style: {
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "20px",
            } }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }, isVisualizationNeeded && !isVisualizationFinal && (currentStep === 0) &&
            react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.nextBotton, { width: '50%' }), onClick: () => renderVisualizeTable() }, "Visualization")),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8 }, subStepperData && react_1.default.createElement(sub_layout_1.SubLayout, { data: subStepperData, setCurrentStepByClick: setCurrentStepByClick, currentStep: currentStep })),
        currentStep === 1 && react_1.default.createElement("div", { style: { paddingLeft: "60%", width: "94%" } },
            react_1.default.createElement(core_1.Button, { style: themes_1.nextBotton, onClick: () => handleTryNewModel() }, "Try New Model"),
            react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.cancelBotton, { color: "#005B96", borderColor: "#005B96" }), onClick: () => increaseStep() }, "View Models")),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12, style: { paddingTop: "30px" } },
            currentStep === 0 && projectInfo.problemtype !== "rca_ms" && react_1.default.createElement(model_tuning_step1_1.ModelTuningStep1, { setModelDetails: setModelDetails, visualizationData: visualizationData, isVisualizationTable: isVisualizationTable, errorMessages: errorMessages }),
            currentStep === 0 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(model_tuning_step_rcams_1_1.ModelTuningRCAStep1, { setModelSelection: setModelSelectionData, errors: errorMessages, setErrorMessage: setErrorMessage }),
            currentStep === 1 && projectInfo.problemtype !== "rca_ms" && react_1.default.createElement(model_tuning_step2_1.ModelTuningStep2, { checkedModelDetails: checkedModelDetails, saveCheckedModel: saveCheckedModel, isModelSaved: isModelSaved, decreaseStep: decreaseStep }),
            currentStep === 1 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(model_tunning_step_rcams_2_1.ModelTuningRCAMSStep2, null),
            currentStep === 2 && react_1.default.createElement(model_tuning_step3_1.ModelTuningStep3, { allSavedModels: allSavedModels, setSelectedFinalModel: setSelectedFinalModel, setIsFinalModelSelected: setIsFinalModelSelected, handleGraphView: handleGraphView, setLoading: setLoading })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: gridSize, lg: gridSize },
            react_1.default.createElement("div", { style: { width: "100%", textAlign: "right" } },
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: themes_1.cancelBotton, onClick: () => decreaseStep(), disabled: isVisualizationFinal }, "Previous"),
                react_1.default.createElement(core_1.Button, { style: Object.assign({}, themes_1.nextBotton, { backgroundColor: (projectInfo.problemType === "anomalydetection" && (modelDetails.algorithm === null || (isVisualizationNeeded && !isVisualizationTable))) ? "gray" : themes_1.nextBotton.backgroundColor }), onClick: () => !isModelSaved && currentStep == 1 ? saveCheckedModel() : increaseStep(), disabled: projectInfo.problemType === "anomalydetection" && (modelDetails.algorithm === null || (isVisualizationNeeded && !isVisualizationTable)) }, !isModelSaved && currentStep == 1 ? 'Save this Model' : 'Next'))),
        react_1.default.createElement(core_1.Snackbar, { open: snackbarOpen, autoHideDuration: 3000, onClose: handleCloseSnackbar, anchorOrigin: { vertical: "bottom", horizontal: "right" } },
            react_1.default.createElement(lab_1.Alert, { onClose: handleCloseSnackbar, severity: "success", variant: "filled", style: { backgroundColor: "#00B1A5" }, sx: { width: '100%'
                } }, "Model saved successfully!")),
        react_1.default.createElement(core_1.Dialog, { open: isGraphView, maxWidth: "md", fullWidth: true, PaperProps: {
                style: { overflow: "hidden" },
            } },
            react_1.default.createElement(core_1.Grid, { container: true },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: styleLocal.graphPopHeader },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", align: "center", gutterBottom: true }, "View Graph"),
                    react_1.default.createElement(core_1.IconButton, { size: "small", onClick: closeGraph },
                        react_1.default.createElement(icons_1.CloseIconColor, null))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 12, style: { overflowX: "auto" } },
                    react_1.default.createElement(graph_component_1.default, { csvPath: graphPath }))))));
}
exports.ModelTuning = ModelTuning;
//# sourceMappingURL=model-tuning.js.map